import React from 'react';

import type {PersonnelResponse} from 'src/api/ProactApiClient';
import UserCourseAssignmentsTable from 'src/app/training/UserCourseAssignmentsTable';

export interface PersonnelTrainingTabProps {
  item?: PersonnelResponse;
}
export const PersonnelTrainingTab: React.FC<PersonnelTrainingTabProps> = ({
  item,
}) => {
  return (
    <UserCourseAssignmentsTable
      apiParams={{
        sessionUserId: item?.id,
      }}
      titleText="Courses"
      enableExport={true}
      enableRefresh={true}
    />
  );
};
